// source: https://bezkoder.com/vue-typescript-crud/
import axios from "axios";

const apiServiceAxios = axios.create({
    baseURL: "https://api.ci.cz",
    headers: {
        "Content-Type": "application/json",
        'X-API-Key': 'SsKd5cX4#vX',
    },
});


// Add a response interceptor
apiServiceAxios.interceptors.request.use(
    config => {
        const accessToken = localStorage.getItem('accessToken')

        if (accessToken != null) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }

        return config
    },
    error => {
        // Do something with request error
        return Promise.reject(error)
    }
)

// Add a response interceptor
apiServiceAxios.interceptors.response.use(
    response => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response
    },
    error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // console.log(error)
        // Reject promise if usual error
        return Promise.reject(error)
    }
)

const CancelToken = axios.CancelToken
let cancelIco

export default {

    /**
     * vrací firmy nalezené podle IČO
     * @param {string} searchText
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchIco(searchText) {
        if (cancelIco !== undefined) {
            cancelIco()
        }
        return apiServiceAxios.get('/katalog_firem/1.0/ico/?searchText=' + searchText, {
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelIco = c
            }),
        })
    },
    /**
     * vrací firmy nalezené podle názvu nebo IČO
     * @param {string} searchText
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchAres(searchText) {
        return apiServiceAxios.get('/katalog_firem/1.0/ares/?searchIco=' + searchText)
    },

    createOrder(crm, id_firmy, opravny_kod, zdroj, platba, cena_bez_dph, sandbox) {
        return apiServiceAxios.get(`/crm/1.0/objednavka_zalozeni/?crm=${crm}&id_firmy=${id_firmy}&opravny_kod=${opravny_kod}&zdroj=${zdroj}&platba=${platba}&cena_bez_dph=${cena_bez_dph}&sandbox=${sandbox}`,
     {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    // Authorization: "Basic " + btoa(client_id + ":" + client_secret)
                }
            }
        );
    },

    /*
    {
  "crm": 1,
  "id_firmy": 5000000,
  "opravny_kod": "2d99532ba898b61754bee9649",
  "id_historie": 381441,
  "hash_objednavky": "6045fc8f40b26",
  "id_produktu": 103,
  "pocet": 1,
  "cena_bez_dph": 1000,
  "sandbox": 0
}
     */

    createNakup(crm, id_firmy, opravny_kod, id_historie, hash_objednavky, id_produktu, pocet, cena_bez_dph, sandbox) {
        return apiServiceAxios.post(`/crm/1.0/objednavka_nakupy/`,
            JSON.stringify({
                crm: crm,
                id_firmy: id_firmy,
                opravny_kod: opravny_kod,
                id_historie: id_historie,
                hash_objednavky: hash_objednavky,
                id_produktu: id_produktu,
                pocet: pocet,
                cena_bez_dph: cena_bez_dph,
                sandbox: sandbox
            }),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    // Authorization: "Basic " + btoa(client_id + ":" + client_secret)
                }
            }
        );
    }
}


